<template>
  <div class="register">
    <div class="qrcode-box">
      <img class="qrcode" src="https://o.666visa.cn/static/ssqwxa/register/register-qrcode-new.jpg" alt="">
    </div>
    <div class="register-label">打开微信扫一扫<br />快速注册</div>
  </div>
</template>
<script>
export default {
  name: 'wxa-register',
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.register{
  display: flex;
  flex-direction: column;
  align-items: center;
  .qrcode-box{
    width: 212px;
    height: 212px;
    padding: 6px;
    .qrcode{
      width: 200px;
      height: 200px;
    }
  }
  .register-label{
    text-align: center;
    margin-top: 10px;
    color: #91999F;
    font-size: 16px;
    line-height: 26px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/login/components/wxa-register.vue